<script setup>
import { translate } from '@/plugins/i18n'
import { WALKER_COMMANDS } from '@/services/helpers/ElbwalkerHelper'
import { useCustomerStore } from '@/stores/customer'
import { elb } from '@elbwalker/walker.js'
import { defineEmits, defineProps, onMounted, ref } from 'vue'

const props = defineProps({
  password: null,
  email: null
})
const emit = defineEmits(['success', 'twoFaAuth'])

const loading = ref(false)
const code = ref('')
const form = ref(null)

const { login2FA } = useCustomerStore()

const rules = {
  minLength: (value) =>
    (value?.length ?? 0) === 6 || translate('validation_msg_min', 6),
  required: (value) => !!value || translate('validation_msg_required')
}

const el = ref(null)

onMounted(() => {
  elb(WALKER_COMMANDS.init, el.value)
})

function changeAction() {
  emit('twoFaAuth')
}

async function twoFactorAuth() {
  loading.value = true
  try {
    await login2FA({ code: code.value })
    emit('success')
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div
    ref="el"
    class="d-flex flex-column"
    data-elb="account"
    data-elb-account="action:two_factor"
    data-elbaction="visible"
  >
    <span class="font-weight-light l-spacing-1">{{
      translate('two_factor_authentication_subline')
    }}</span>
    <VForm
      @submit.prevent="twoFactorAuth"
      ref="form"
      lazy-validation
      class="w-100 d-flex flex-column mt-5"
    >
      <VTextField
        v-model="code"
        :rules="[rules.required, rules.minLength]"
        type="digits:6"
        :label="translate('two_factor_authentication_code')"
        @keydown.enter="twoFactorAuth"
      />
      <VBtn
        color="primary"
        class="mt-3"
        @click="twoFactorAuth"
        :loading="loading"
        :disabled="loading"
        depressed
        block
      >
        {{ translate('two_factor_authentication_verify') }}
      </VBtn>
    </VForm>
  </div>
</template>
